<template>
  <el-menu :default-active="$route.path" :unique-opened="true" :router="true">
    <template v-for="(v, i) in menus">
      <el-submenu v-if="!!v.children" :key="i" :index="i.toString()">
        <template slot="title">
          <i :class="v.icon"></i>
          <span>{{ v.label }}</span>
        </template>
        <el-menu-item :disabled="!sub.route" v-for="(sub, idx) in v.children" :key="idx" :index="sub.route">{{ sub.label
        }}</el-menu-item>
      </el-submenu>
      <el-menu-item :disabled="!v.route" v-else :key="i" :index="v.route">
        <i :class="v.icon"></i>
        <span slot="title">{{ v.label }}</span>
      </el-menu-item>
    </template>
  </el-menu>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      menus: [
        {
          label: '用户中心',
          route: '/user',
          icon: 'el-icon-user'
        },
        {
          label: '我的订单',
          icon: 'el-icon-tickets',
          children: [
            {
              label: '订单中心',
              route: '/orderCenter',
            },
            {
              label: '签证订单',
              route: '/order_list',
            }, {
              label: '酒店订单',
              route: '/hotel_order',
            }, {
              label: '旅游订单',
              route: '/tour/order_list',
            }]
        }, {
          label: '我的钱包',
          route: null,
          icon: 'el-icon-shopping-bag-1',
        },
        // {
        //   label: '业绩提成',
        //   route: '/commission',
        //   icon: 'el-icon-data-line'
        // },
        {
          label: '优惠券',
          icon: 'el-icon-document-copy',
          children: [{
            label: '优惠券列表',
            route: '/coupon_list',
          }, {
            label: '可领取优惠券',
            route: '/get_coupon'
          }]
        }, {
          label: '我的发票',
          route: null,
          icon: 'el-icon-postcard'
        }, {
          label: '收件地址',
          route: '/address',
          icon: 'el-icon-location-information'
        }, {
          label: '进度查询',
          route: null,
          icon: 'el-icon-search'
        }, {
          label: '账户设置',
          route: null,
          icon: 'el-icon-setting',
          children: [{
            label: '我的账户',
            route: '/myuser',
          }, {
            label: '修改密码',
            route: '/update_pwd',
          }, {
            label: '修改资料',
            route: '/update_info',
          }]
        }, {
          label: '系统消息',
          route: null,
          icon: 'el-icon-bell'
        }
      ]
    }
  },
  created() {
  },
  methods: {
    changeSelect(index) {
      this.activeMenu = index;
    }
  }
}
</script>

<style scoped src="./index.css"></style>